"use strict";

var SUBSCRIPTION_IS_ACTIVE = 1;

// Ad status constants
var AD_ACTIVE_BUT_HIDDEN = 'ACTIVE_BUT_HIDDEN';
var AD_CREATED = 'DRAFTED';
var AD_ACTIVE = 'ACTIVE';
var AD_READY = 'READY';
var AD_INACTIVE = 'INACTIVE';
var AD_EXPIRED = 'EXPIRED';
var ALL_AD_STATUS_STATES = [AD_ACTIVE_BUT_HIDDEN, AD_CREATED, AD_READY, AD_ACTIVE, AD_INACTIVE, AD_EXPIRED];

// REGEX
var URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/gi;

// KEYSTROKES
var ENTER_KEY = 13;
var CDN_IMAGE_SRC = 'https://static.finncdn.no/_c/new-construction-podlet-assets';
var NO_IMAGE_SRC = 'https://static.finncdn.no/_c/mfinn/static/images/no-image.5bf83e47.svg';

// AD TYPES
var AD_TYPE_KFS = 'kfs';
var AD_TYPE_KFS_LEISURE = 'kfs_leisure';
var AD_TYPE_PTS = 'pts';
var AD_TYPE_PTS_UNIT = 'pts_unit';
var AD_TYPE_ETS = 'efs'; // TODO: NYB-2539 rename to ets when API returns ets as adType
var AD_TYPE_PTSF = 'ptsf';
var AD_TYPE_PTSF_UNIT = 'ptsf_unit';
var AD_TYPES = {
  AD_TYPE_KFS: AD_TYPE_KFS,
  AD_TYPE_PTS: AD_TYPE_PTS,
  AD_TYPE_PTS_UNIT: AD_TYPE_PTS_UNIT,
  AD_TYPE_ETS: AD_TYPE_ETS,
  AD_TYPE_PTSF: AD_TYPE_PTSF,
  AD_TYPE_PTSF_UNIT: AD_TYPE_PTSF_UNIT
};
var AD_TYPES_WITH_DIGITAL = [AD_TYPE_KFS];
var AD_TYPES_WITH_PRINT = [AD_TYPE_KFS];
var TEST_ORGID = '89379898';
var BLINK_ALREADY_PURCHASED = 'BLINK_ALREADY_PURCHASED';
var BLINK_NOT_AVAILABLE = 'BLINK_NOT_AVAILABLE';
var BLINK_SUBSCRIPTION_END_OVERLAP = 'BLINK_SUBSCRIPTION_END_OVERLAP';
var LIFTING_ALREADY_PURCHASED = 'LIFTING_ALREADY_PURCHASED';
var MARKETING_PRODUCT_UNAVAILABLE = 'PRODUCT_UNAVAILABLE';
var PROJECT_STAGE_1 = 'Planlegging';
var PROJECT_STAGE_2 = 'Salgsstart';
var PROJECT_STAGE_3 = 'Byggestart';
var PROJECT_STAGE_4 = 'Innflytting';
var PROJECT_STAGE_4_TEXT = 'Overtakelse';
var LINK_PROJECT_TOAST = 'linkFromProject';
var LINK_KFS_TOAST = 'linkFromKfs';
var PROJECT_FROM_KFS_TOAST = 'projectFromKfs';
var AD_CHANGED_TOAST = 'adChanged';
var AD_PUBLISHED_TOAST = 'adPublished';
module.exports = {
  SUBSCRIPTION_IS_ACTIVE: SUBSCRIPTION_IS_ACTIVE,
  AD_ACTIVE_BUT_HIDDEN: AD_ACTIVE_BUT_HIDDEN,
  AD_CREATED: AD_CREATED,
  AD_READY: AD_READY,
  AD_ACTIVE: AD_ACTIVE,
  AD_INACTIVE: AD_INACTIVE,
  AD_EXPIRED: AD_EXPIRED,
  ALL_AD_STATUS_STATES: ALL_AD_STATUS_STATES,
  ENTER_KEY: ENTER_KEY,
  NO_IMAGE_SRC: NO_IMAGE_SRC,
  AD_TYPES: AD_TYPES,
  AD_TYPE_KFS: AD_TYPE_KFS,
  AD_TYPE_KFS_LEISURE: AD_TYPE_KFS_LEISURE,
  AD_TYPE_PTS: AD_TYPE_PTS,
  AD_TYPE_PTS_UNIT: AD_TYPE_PTS_UNIT,
  AD_TYPE_ETS: AD_TYPE_ETS,
  AD_TYPE_PTSF: AD_TYPE_PTSF,
  AD_TYPE_PTSF_UNIT: AD_TYPE_PTSF_UNIT,
  AD_TYPES_WITH_DIGITAL: AD_TYPES_WITH_DIGITAL,
  AD_TYPES_WITH_PRINT: AD_TYPES_WITH_PRINT,
  BLINK_ALREADY_PURCHASED: BLINK_ALREADY_PURCHASED,
  BLINK_NOT_AVAILABLE: BLINK_NOT_AVAILABLE,
  BLINK_SUBSCRIPTION_END_OVERLAP: BLINK_SUBSCRIPTION_END_OVERLAP,
  MARKETING_PRODUCT_UNAVAILABLE: MARKETING_PRODUCT_UNAVAILABLE,
  TEST_ORGID: TEST_ORGID,
  URL_REGEX: URL_REGEX,
  CDN_IMAGE_SRC: CDN_IMAGE_SRC,
  PROJECT_STAGE_1: PROJECT_STAGE_1,
  PROJECT_STAGE_2: PROJECT_STAGE_2,
  PROJECT_STAGE_3: PROJECT_STAGE_3,
  PROJECT_STAGE_4: PROJECT_STAGE_4,
  PROJECT_STAGE_4_TEXT: PROJECT_STAGE_4_TEXT,
  PROJECT_FROM_KFS_TOAST: PROJECT_FROM_KFS_TOAST,
  LINK_PROJECT_TOAST: LINK_PROJECT_TOAST,
  LINK_KFS_TOAST: LINK_KFS_TOAST,
  AD_PUBLISHED_TOAST: AD_PUBLISHED_TOAST,
  AD_CHANGED_TOAST: AD_CHANGED_TOAST,
  LIFTING_ALREADY_PURCHASED: LIFTING_ALREADY_PURCHASED
};